export * from './announcements.service';
import { AnnouncementsService } from './announcements.service';
export * from './attendance.service';
import { AttendanceService } from './attendance.service';
export * from './childPortfolioActivities.service';
import { ChildPortfolioActivitiesService } from './childPortfolioActivities.service';
export * from './childPortfolioChildSkillStats.service';
import { ChildPortfolioChildSkillStatsService } from './childPortfolioChildSkillStats.service';
export * from './childPortfolioChildTimeline.service';
import { ChildPortfolioChildTimelineService } from './childPortfolioChildTimeline.service';
export * from './childPortfolioChildren.service';
import { ChildPortfolioChildrenService } from './childPortfolioChildren.service';
export * from './childPortfolioCompetencies.service';
import { ChildPortfolioCompetenciesService } from './childPortfolioCompetencies.service';
export * from './childPortfolioKorab.service';
import { ChildPortfolioKorabService } from './childPortfolioKorab.service';
export * from './childPortfolioLiteracy.service';
import { ChildPortfolioLiteracyService } from './childPortfolioLiteracy.service';
export * from './childPortfolioNotes.service';
import { ChildPortfolioNotesService } from './childPortfolioNotes.service';
export * from './childPortfolioRecords.service';
import { ChildPortfolioRecordsService } from './childPortfolioRecords.service';
export * from './childPortfolioShipLog.service';
import { ChildPortfolioShipLogService } from './childPortfolioShipLog.service';
export * from './childPortfolioSkillAreas.service';
import { ChildPortfolioSkillAreasService } from './childPortfolioSkillAreas.service';
export * from './childPortfolioSkillProgress.service';
import { ChildPortfolioSkillProgressService } from './childPortfolioSkillProgress.service';
export * from './childPortfolioSkillsList.service';
import { ChildPortfolioSkillsListService } from './childPortfolioSkillsList.service';
export * from './childPortfolioSkillsStats.service';
import { ChildPortfolioSkillsStatsService } from './childPortfolioSkillsStats.service';
export * from './childPortfolioStatistics.service';
import { ChildPortfolioStatisticsService } from './childPortfolioStatistics.service';
export * from './childPortfolioStats.service';
import { ChildPortfolioStatsService } from './childPortfolioStats.service';
export * from './childPortfolioWatched.service';
import { ChildPortfolioWatchedService } from './childPortfolioWatched.service';
export * from './children.service';
import { ChildrenService } from './children.service';
export * from './childrenGroup.service';
import { ChildrenGroupService } from './childrenGroup.service';
export * from './cities.service';
import { CitiesService } from './cities.service';
export * from './classes.service';
import { ClassesService } from './classes.service';
export * from './closeRelatives.service';
import { CloseRelativesService } from './closeRelatives.service';
export * from './contracts.service';
import { ContractsService } from './contracts.service';
export * from './dayOffs.service';
import { DayOffsService } from './dayOffs.service';
export * from './districts.service';
import { DistrictsService } from './districts.service';
export * from './documents.service';
import { DocumentsService } from './documents.service';
export * from './eEnrollment.service';
import { EEnrollmentService } from './eEnrollment.service';
export * from './emailVerification.service';
import { EmailVerificationService } from './emailVerification.service';
export * from './enrollmentTransfer.service';
import { EnrollmentTransferService } from './enrollmentTransfer.service';
export * from './exportXml.service';
import { ExportXmlService } from './exportXml.service';
export * from './gradeBook.service';
import { GradeBookService } from './gradeBook.service';
export * from './gradeBookThematicBlocks.service';
import { GradeBookThematicBlocksService } from './gradeBookThematicBlocks.service';
export * from './invitations.service';
import { InvitationsService } from './invitations.service';
export * from './kindergarten.service';
import { KindergartenService } from './kindergarten.service';
export * from './kindergartenUsers.service';
import { KindergartenUsersService } from './kindergartenUsers.service';
export * from './loggedTeacher.service';
import { LoggedTeacherService } from './loggedTeacher.service';
export * from './mSMT.service';
import { MSMTService } from './mSMT.service';
export * from './organization.service';
import { OrganizationService } from './organization.service';
export * from './papCategories.service';
import { PapCategoriesService } from './papCategories.service';
export * from './phoneVerification.service';
import { PhoneVerificationService } from './phoneVerification.service';
export * from './portfolio.service';
import { PortfolioService } from './portfolio.service';
export * from './registration.service';
import { RegistrationService } from './registration.service';
export * from './speechToText.service';
import { SpeechToTextService } from './speechToText.service';
export * from './supportingMeasures.service';
import { SupportingMeasuresService } from './supportingMeasures.service';
export * from './switchDemoKindergarten.service';
import { SwitchDemoKindergartenService } from './switchDemoKindergarten.service';
export * from './teacherInvitations.service';
import { TeacherInvitationsService } from './teacherInvitations.service';
export * from './teacherResults.service';
import { TeacherResultsService } from './teacherResults.service';
export * from './teachers.service';
import { TeachersService } from './teachers.service';
export * from './transitionReports.service';
import { TransitionReportsService } from './transitionReports.service';
export * from './unifiedChildHistory.service';
import { UnifiedChildHistoryService } from './unifiedChildHistory.service';
export * from './unifiedGroupHistory.service';
import { UnifiedGroupHistoryService } from './unifiedGroupHistory.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [AnnouncementsService, AttendanceService, ChildPortfolioActivitiesService, ChildPortfolioChildSkillStatsService, ChildPortfolioChildTimelineService, ChildPortfolioChildrenService, ChildPortfolioCompetenciesService, ChildPortfolioKorabService, ChildPortfolioLiteracyService, ChildPortfolioNotesService, ChildPortfolioRecordsService, ChildPortfolioShipLogService, ChildPortfolioSkillAreasService, ChildPortfolioSkillProgressService, ChildPortfolioSkillsListService, ChildPortfolioSkillsStatsService, ChildPortfolioStatisticsService, ChildPortfolioStatsService, ChildPortfolioWatchedService, ChildrenService, ChildrenGroupService, CitiesService, ClassesService, CloseRelativesService, ContractsService, DayOffsService, DistrictsService, DocumentsService, EEnrollmentService, EmailVerificationService, EnrollmentTransferService, ExportXmlService, GradeBookService, GradeBookThematicBlocksService, InvitationsService, KindergartenService, KindergartenUsersService, LoggedTeacherService, MSMTService, OrganizationService, PapCategoriesService, PhoneVerificationService, PortfolioService, RegistrationService, SpeechToTextService, SupportingMeasuresService, SwitchDemoKindergartenService, TeacherInvitationsService, TeacherResultsService, TeachersService, TransitionReportsService, UnifiedChildHistoryService, UnifiedGroupHistoryService, UsersService];
